import React from 'react';
import { Input, Label } from 'reactstrap';
import { T } from '../traks';

const GenderSelector = (props) => {
    const setGenderType = (type) => {
        const typeMap = {
            'Male': <T>Male</T>,
            'Female': <T>Female</T>,
            'Other': <T>Other</T>,
        };

        return typeMap[type] || type;
    }

    return (
        <div>
            <div className="mb-2"><b><T>Gender:</T></b></div>
            {['Male', 'Female', 'Other'].map((gender) => {
                return (
                <div key={`gender-${gender.toLowerCase()}`} className='radio-item pr-lg-3'>
                    <Input type="radio" className="form-check-input" id={`gender_${gender.toLowerCase()}`} name="gender" value={gender.toLowerCase()} checked={gender.toLowerCase() === props.gender} onChange={props.onChange} /> 
                    <Label className="form-check-label" for={`gender_${gender.toLowerCase()}`}>
                        <span>{setGenderType(gender)}</span>
                    </Label>
                </div>
            )})}
        </div>
    )
}

export default GenderSelector;


// WEBPACK FOOTER //
// ./src/c/GenderInput.js